import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rightArrow",
  "use": "rightArrow-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"rightArrow\"><g data-name=\"icon - right arrow link - 12px\"><path d=\"M0 0h12v12H0z\" fill=\"none\" /><path data-name=\"↳color\" d=\"M10.717 5.628L7.973 2.897a.525.525 0 0 0-.741.744l1.842 1.833h-7.42a.525.525 0 0 0 0 1.05h7.42L7.229 8.358a.525.525 0 0 0 .741.744l2.744-2.731a.526.526 0 0 0 .003-.743z\" fill=\"currentColor\" stroke=\"currentColor\" stroke-width=\".25\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol